import { AsyncPipe } from '@angular/common';
import { Component, forwardRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { map } from 'rxjs/operators';
import { AbstractFilterDropdownComponent } from 'shared/components/atoms';
import { YardOperations } from 'shared/enums/yard-operations.enum';
import { TaskService } from 'shared/services/task.service';
import { TaskTypes } from 'shared/types';
import { FilterDropdownComponent } from '../filter-dropdown/filter-dropdown.component';

@Component({
  selector: 'app-task-types-dropdown',
  templateUrl: './task-types-dropdown.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TaskTypesDropdownComponent),
      multi: true,
    },
  ],
  imports: [FilterDropdownComponent, ReactiveFormsModule, AsyncPipe],
})
export class TaskTypesDropdownComponent extends AbstractFilterDropdownComponent<TaskTypes['code']> {
  private taskService = inject(TaskService);
  public taskTypes$ = this.taskService
    .getTasksTypes()
    .pipe(map((types) => types.filter((type) => type.code !== YardOperations.SHUTTLE).map((type) => ({ ...type }))));

  constructor() {
    super();
    this.formControl.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((value: TaskTypes['code']) => {
      this.onChange(value);
    });
  }
}
